import { ClassActuality } from '../../enums/class-actuality';
import { ApiGetRequest } from './api-get-request';
import { ApiParameters } from './api-parameters';

export class LotterySaleStopRequest extends ApiGetRequest
{
    public constructor(webapiBasepath: string, saleActuality?: ClassActuality)
    {
        const parameters = saleActuality ? new ApiParameters()
        .addQueryParameter('saleActuality', saleActuality.toString()) : null;
        
        super('nextsalestop', parameters, null, webapiBasepath);
    }
}
